import { Link, useParams } from "wouter";
import { Upload, PlugsConnected } from "@phosphor-icons/react";
import { useQueryState } from "nuqs";
import { phaseRegistry } from "../registry.js";
import { PhaseTile } from "../components.js";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { IntegrationTable, PostTable } from "../table.js";
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateIcon,
  EmptyStateTitle,
  EmptyStateDescription,
} from "@/components/ui/empty-state";

const OutboxPage = () => {
  const [tab, setTab] = useQueryState("tab", { defaultValue: "posts" });
  const { orgSlug } = useParams<{ orgSlug: string }>();

  return (
    <Tabs value={tab} onValueChange={setTab}>
      <div className="flex items-center justify-between">
        <TabsList>
          <TabsTrigger value="posts">Posts</TabsTrigger>
          <TabsTrigger value="channels">Channels</TabsTrigger>
        </TabsList>
        {tab === "channels" && (
          <Button asChild>
            <Link href={`/o/${orgSlug}/channels`}>Add channel</Link>
          </Button>
        )}
      </div>
      <TabsContent value="posts">
        <PostTable search="phase:outbox or phase:failed or phase:published" />
      </TabsContent>
      <TabsContent value="channels">
        <IntegrationTable
          search="kind:channel"
          emptyState={
            <EmptyState>
              <EmptyStateIcon>
                <PlugsConnected />
              </EmptyStateIcon>
              <EmptyStateTitle>No channels configured</EmptyStateTitle>
              <EmptyStateDescription>
                Connect channels to publish posts to external destinations.
              </EmptyStateDescription>
              <EmptyStateActions>
                <Button asChild>
                  <Link href={`/o/${orgSlug}/channels`}>Add channel</Link>
                </Button>
              </EmptyStateActions>
            </EmptyState>
          }
        />
      </TabsContent>
    </Tabs>
  );
};

const OutboxTile = () => {
  return (
    <PhaseTile phase="outbox">
      <Upload size={24} />
    </PhaseTile>
  );
};

phaseRegistry.register({
  type: "outbox",
  order: 6,
  page: OutboxPage,
  tile: OutboxTile,
});
